import { getLanguage } from 'common/Utils/LocalStorageUtilities'
import { getDate, getDateWithoutHour } from 'common/Utils/StringUtilities'
import { weekdays } from 'constants/dates'
import { OrderStatus } from 'constants/orderStatus'
import { ProductionStatus } from 'constants/productionStatus'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'

const RealShipmentDateWithoutDayName = ({ date, realDate, t, delayDate, statusSupplierProduction, statusOrder }) => {
	const DAY = t('format_day', { ns: 'naming' })
	const DAYS = t('days', { ns: 'naming' })

	const getWeekDay = (dateStr, language) => {
		const date = new Date(dateStr)
		const days = date.getDay()
		return weekdays[days][language] + ' '
	}

	const getRemainingDays = date => {
		const shipmentDate = getDateWithoutHour(new Date(date))
		const actualDate = getDateWithoutHour(new Date())
		return Math.floor((shipmentDate - actualDate) / 86400000)
	}

	const getDifferenceDays = (estimatedDate, realDate) => {
		const estimated = getDateWithoutHour(new Date(estimatedDate))
		const real = getDateWithoutHour(new Date(realDate))
		return Math.floor((estimated - real) / 86400000)
	}

	useEffect(() => {
		if (date) {
			const remainingDays = getRemainingDays(date)
			setRemainingDays(remainingDays)
			setClassNameIcon(getClassName(remainingDays))
		}
	}, [date])

	let leftOrLate = t('remaining', { ns: 'naming' })

	const getClassName = days => {
		switch (true) {
			case 1 == days || 0 == days:
				return 'bx bxs-circle text-danger me-1'
			case 0 > days:
				leftOrLate = t('late', { ns: 'naming' })
				return 'bx bxs-circle text-danger me-1'
			case 0 < days:
				return 'bx bxs-circle text-success me-1'
		}
	}

	const [remainingDays, setRemainingDays] = useState(getRemainingDays(date))
	const [classNameIcon, setClassNameIcon] = useState(getClassName(remainingDays))

	const showRemainingDays = ![
		ProductionStatus.CANCELLED,
		ProductionStatus.DENIED,
	].includes(statusSupplierProduction)

	const showRemainingDaysOrders = ![
		OrderStatus.CANCELLED,
		OrderStatus.REFUNDED,
		OrderStatus.PAYMENT_ERROR,
	].includes(statusOrder)

	const showDays = showRemainingDays && showRemainingDaysOrders

	const differenceDays = realDate ? getDifferenceDays(date, realDate) : null

	return (
		<div>
			{date && (
				<div>
					<span>
						{getDate(date, getLanguage())} {!realDate && getWeekDay(date, getLanguage())}
						<small>(ESTM)</small>
					</span>
					<div>
						{realDate == '' || realDate == undefined ? (
							showDays == true ? (
								<div className="pb-1">
									<i className={classNameIcon}></i>
									<span>
										{remainingDays}
										{Math.abs(remainingDays) == 1
											? ` ${DAY} ${leftOrLate}`
											: ` ${DAYS} ${leftOrLate}`}
									</span>
								</div>) : (<div></div>)
						) : (
							<div className='d-flex'>
								<strong>
									{realDate && getDate(realDate, getLanguage())}
									<small> (REAL)</small>
								</strong>
								{differenceDays != null && (
									<div className="d-flex align-items-center ms-2">
										<i className={differenceDays >= 0 ? 'bx bxs-circle text-success me-1' : 'bx bxs-circle text-danger me-1'}></i>
										<span>
											{differenceDays >= 0
												? `+${differenceDays} ${differenceDays === 1 ? DAY : DAYS} ${t('before', { ns: 'naming' })}`
												: `-${Math.abs(differenceDays)} ${Math.abs(differenceDays) === 1 ? DAY : DAYS} ${t('late', { ns: 'naming' })}`
											}										</span>
									</div>
								)}
							</div>
						)}

					</div>
				</div>
			)}
		</div>
	)
}

RealShipmentDateWithoutDayName.propTypes = {
	date: PropTypes.string,
	realDate: PropTypes.string,
	delayDate: PropTypes.string,
	statusSupplierProduction: PropTypes.number,
	statusOrder: PropTypes.number,
	t: PropTypes.func,
}

export default withTranslation()(RealShipmentDateWithoutDayName)
